module.exports = __webpack_public_path__ + "static/media/survey-surface.c24b1baa.png";